import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { FileText, Eye, Edit2, Trash2, Plus } from 'lucide-react'
import axios from '../../lib/axios'
import '../Pages.css'

export default function Templates() {
  const [templates, setTemplates] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [previewTemplate, setPreviewTemplate] = useState(null)

  useEffect(() => {
    fetchTemplates()
  }, [])

  const fetchTemplates = () => {
    setLoading(true)
    axios
      .get('master-templates/')
      .then((res) => {
        setTemplates(res.data)
        setError(null)
      })
      .catch((err) => {
        console.error('Error fetching templates:', err)
        setError('Failed to load templates')
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const handleDelete = async (templateId) => {
    if (!confirm('Are you sure you want to delete this template?')) return

    try {
      await axios.delete(`master-templates/${templateId}`)
      alert('Template deleted successfully')
      fetchTemplates()
    } catch (err) {
      console.error('Error deleting template:', err)
      alert('Failed to delete template')
    }
  }

  const closePreview = () => {
    setPreviewTemplate(null)
  }

  return (
    <div className="page templates-page animate-fade-in">
      <div className="page-header">
        <div className="header-info">
          <h2>Email Templates</h2>
          <p>Create and manage your email templates for campaigns</p>
        </div>
        <Link to="/templates/create" className="btn btn-primary">
          <Plus size={18} />
          <span>Create Template</span>
        </Link>
      </div>

      <div className="card">
        {loading ? (
          <div style={{ padding: '3rem', textAlign: 'center' }}>
            <div className="loader" style={{ margin: '0 auto' }}></div>
            <p style={{ marginTop: '1rem', color: 'var(--color-text-muted)' }}>Loading templates...</p>
          </div>
        ) : error ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--color-error)' }}>
            {error}
          </div>
        ) : (
          <div className="table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Template Name</th>
                  <th>Subject</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {templates.length > 0 ? (
                  templates.map((template, index) => (
                    <tr key={template.id}>
                      <td className="font-medium">{index + 1}</td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <FileText size={16} style={{ color: 'var(--color-text-muted)' }} />
                          {template.name || 'Untitled Template'}
                        </div>
                      </td>
                      <td>{template.subject || '-'}</td>
                      <td>
                        <div className="action-buttons">
                          <button
                            className="icon-btn"
                            onClick={() => setPreviewTemplate(template)}
                            title="Preview"
                          >
                            <Eye size={18} />
                          </button>
                          <Link to={`/templates/edit/${template.id}`}>
                            <button className="icon-btn" title="Edit Template">
                              <Edit2 size={18} />
                            </button>
                          </Link>
                          <button
                            className="icon-btn danger"
                            onClick={() => handleDelete(template.id)}
                            title="Delete"
                          >
                            <Trash2 size={18} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={{ textAlign: 'center', padding: '2rem', color: 'var(--color-text-muted)' }}>
                      No templates found. Create your first template to get started!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Preview Modal */}
      {previewTemplate && (
        <div className="modal-overlay" onClick={closePreview}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '900px' }}>
            <div className="modal-header">
              <h3>
                <Eye size={20} style={{ verticalAlign: 'middle', marginRight: '0.5rem' }} />
                Preview: {previewTemplate.name || 'Template'}
              </h3>
              <button className="icon-btn" onClick={closePreview}>
                <span style={{ fontSize: '1.5rem', lineHeight: '1' }}>&times;</span>
              </button>
            </div>
            <div className="modal-form">
              {previewTemplate.subject && (
                <div style={{ marginBottom: '1rem', padding: '1rem', background: 'var(--color-bg-primary)', borderRadius: 'var(--radius-md)' }}>
                  <div style={{ fontSize: '0.75rem', color: 'var(--color-text-muted)', marginBottom: '0.25rem' }}>Subject:</div>
                  <div style={{ fontWeight: '600' }}>{previewTemplate.subject}</div>
                </div>
              )}
              <div
                style={{
                  padding: '1.5rem',
                  background: '#ffffff',
                  border: '1px solid var(--color-border)',
                  borderRadius: 'var(--radius-md)',
                  maxHeight: '60vh',
                  overflowY: 'auto'
                }}
                dangerouslySetInnerHTML={{ __html: previewTemplate.html || '<p>No content available</p>' }}
              />
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={closePreview}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
